import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  me: null,
  permissions: null,
  fetchedCreateUserSuccess: false,
  fetchingCreateUser: false,
  fetchingPermissions: false,
  errors: {},
  organizations: {
    list: [],
    pagination: {},
    fetchedUserOrgs: false,
    fetchingUserOrgs: false,
  },
};

const userReducer = createReducer(initialState)({
  [types.FETCH_USER_PRIVILEGES_REQUEST]: (state) => {
    return {
      ...state,
      permissions: null,
      fetchingPermissions: true,
    };
  },
  [types.FETCH_USER_PRIVILEGES_SUCCESS]: (state, { payload }) => {
    let permissions = payload?.privileges || {};

    if (permissions?.privileges) {
      permissions = permissions.privileges || {};
    }

    return {
      ...state,
      permissions,
      fetchingPermissions: false,
    };
  },
  [types.FETCH_USER_PRIVILEGES_FAILED]: (state, { error }) => {
    return {
      ...state,
      permissions: null,
      fetchingPermissions: false,
    };
  },
  // CREATE USER
  [types.CREATE_USER_REQUEST]: (state) => {
    return {
      ...state,
      fetchedCreateUserSuccess: false,
      fetchingCreateUser: true,
    };
  },
  [types.CREATE_USER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedCreateUserSuccess: true,
      fetchingCreateUser: false,
    };
  },
  [types.CREATE_USER_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchedCreateUserSuccess: false,
      fetchingCreateUser: false,
      errors,
    };
  },
  // FETCH USER ORGANIZATIONS
  [types.FETCH_USER_ORGANIZATIONS_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUserOrganizations: false,
      fetchingUserOrganizations: true,
    };
  },
  [types.FETCH_USER_ORGANIZATIONS_SUCCESS]: (state, { payload }) => {
    const data =
      payload?.pagination?.currentPage === 1
        ? payload?.data
        : [...state.organizations.list, ...payload.data];
    return {
      ...state,
      fetchedUserOrganizations: true,
      fetchingUserOrganizations: false,
      organizations: {
        ...state.organizations,
        list: data,
        pagination: payload.pagination,
      },
    };
  },
  [types.FETCH_USER_ORGANIZATIONS_FAILED]: (state) => {
    return {
      ...state,
      fetchedUserOrganizations: false,
      fetchingUserOrganizations: false,
    };
  },
  // RESET CREATE USER
  [types.RESET_CREATE_USER_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedCreateUserSuccess: false,
      fetchingCreateUser: false,
      errors: {},
    };
  },
});

export default userReducer;
